<template>
    <div class="employmentFx">
        <div class="main">
            <div class="info position-relative" style="min-height:520px;">
<!--                salary.length>0&&-->
                <div v-show="!loadingData">
                    <div  class="sonTitle font-weight-bolder text-m-size">{{name}}</div>
                    <div class="margin-top w-100 " style="min-height:520px;width:940px;margin:20px auto 0 auto;">
                        <div id="jyzx" class="float-left" style="width: 420px;min-height: 520px;margin-bottom: 30px;"></div>
                        <div id="csfb" class="float-left" style="width: 420px; min-height: 500px; margin-left: 100px;"></div>
                    </div>
                </div>
                <loading v-show="loadingData" width="1025px"></loading>
                <empty v-show="salary.length<1&&!loadingData" content="暂无相关内容"></empty>
            </div>
            <div class="info position-relative" style="min-height:600px;">
                <div v-show="salary.length>0&&!loadingData">

                    <div class="w-100 margin-top" style="min-height:600px;">
                        <div id="zxt" style="width:100%;min-height: 600px;">

                        </div>
                    </div>
                </div>
                <loading v-show="loadingData" width="1025px"></loading>
                <empty v-show="salary.length<1&&!loadingData" content="暂无相关内容"></empty>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from "../../../../assets/static/global/event-bus";
    import {professionEmployment} from "../../../../config";
    export default{
        name: "professionEmploymentFx",
        props:{
            professionId:String
        },
        data(){
            return{
                loadingData:false,
                employmentData:'',
                hyDataList:[],
                salary:[],
                cityData:[],
                //行业分布
                tradeData:[],
                //薪资Data数据内容
                salaryData:[],
                name:''
            }
        },
        mounted(){
            EventBus.$on('professionJx',((res)=>{
                this.name=res.name;
                this.searchPJyJx();
            }))
        },
        methods:{
            //查出就业解析
            async searchPJyJx(){
                this.loadingData=true;
                let result=await professionEmployment(this.professionId);
                if(result.status){
                    this.loadingData=false;
                    this.hyDataList=[];
                    this.salary=[];
                    this.salaryData=result.data.salary;
                    this.cityData=result.data.workCity;
                    this.tradeData= result.data.trade;
                    result.data.salary.forEach((val,index)=>{
                        this.hyDataList.push(Math.floor(val.monthlySalary)/1000);
                        this.salary.push( val.workingAge+'年' )
                    });
                    let cityNameList=[];
                    let cityValue=[];
                    this.cityData.forEach((val)=>{
                        cityNameList.push(val.cityName);
                        cityValue.push( val.proportion);
                    })
                    console.log(this.tradeData);
                    console.log(this.cityData);
                    console.log( result.data.salary);
                    //查出右侧统计图
                    this.showCsfb(cityNameList,cityValue);
                    let industry=[];
                    let ratio=[];
                    //查出底部折线图
                    this.tradeData.forEach((val)=>{
                        industry.push(val.position);
                        ratio.push({name:val.position,value:val.proportion});
                    });
                    //查出行业走向
                    this.showJyZx(ratio,industry);
                    this.showCityXc();
                }else{
                    this.loadingData=false;
                }
            },
            //就业走向echarts
            showJyZx(cityNameList,cityValue){
                this.$nextTick(()=>{
                    let myCharts=this.$echarts.init(document.getElementById('jyzx'));
                    myCharts.setOption({
                        title: {
                            text: '行业分布'
                        },
                        tooltip: {
                            trigger: 'item',
                            formatter: '{b} :{d}%'
                        },
                        color: ['#FF9F7F','#9FE6B8','#32C5E9','#FEC20A','#412F2E','#0099FF','#FF0000','#C759FF','#19A033','#0C0C59'],

                        legend: {
                            bottom: 10,
                            left: 'center',
                            data: cityValue
                        },
                        series: [
                            {
                                type: 'pie',
                                radius: '65%',
                                center: ['50%', '50%'],
                                selectedMode: 'single',
                                data:cityNameList,
                                emphasis: {
                                    itemStyle: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    })
                })
            },
            //展示毕业生平均薪酬
            showCityXc(){
                this.$nextTick(()=>{
                    let myCharts=this.$echarts.init(document.getElementById('zxt'));
                    myCharts.setOption({
                        title: {
                            text: '毕业生平均薪酬',

                            left:'left'
                        },
                        tooltip: {
                            trigger: 'axis'
                        },
                        color: ['#32C5E9'],
                        toolbox: {
                            show: true,
                            feature: {
                                dataZoom: {
                                    yAxisIndex: 'none'
                                },
                                dataView: {readOnly: false},
                                magicType: {type: ['line', 'bar']},
                                restore: {},
                                saveAsImage: {}
                            }
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: this.salary
                        },
                        yAxis: {
                            type: 'value',
                            axisLabel: {
                                formatter: '{value}k'
                            }
                        },
                        series: [
                            {
                                name: '薪资',
                                type: 'line',
                                data: this.hyDataList,
                                markPoint: {
                                    data: [
                                        {type: 'max', name: '最大值'},
                                        {type: 'min', name: '最小值'}
                                    ]
                                },
                                markLine: {
                                    data: [
                                        {type: 'average', name: '平均值'}
                                    ]
                                }
                            }]
                    })
                })
            },
            //展示城市分布
            showCsfb(valCityName,cityValue){
                console.log('城市名称');
                console.log(valCityName);
                console.log('城市value');
                console.log(cityValue);
                this.$nextTick(()=>{
                    let myChartss=this.$echarts.init(document.getElementById('csfb'));
                    myChartss.setOption({
                        title: {
                            text: '城市分布'
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        // legend: {
                        //     data: ['2011年', '2012年']
                        // },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {

                        },
                        yAxis: {
                            type: 'category',
                            data:valCityName,
                        },
                        series: [
                            {
                                name:'占比',
                                type:'bar',
                                data:cityValue,
                                itemStyle:{
                                    normal:{
                                        color:["#f2382b"],
                                        label:{
                                            show:true,
                                            formatter:'{c}%',
                                            position:'right'
                                        },
                                        // color: this.$echarts.graphic.LinearGradient(
                                        //     0, 0, 0, 1,            // 0,0,1,0表示从左向右    0,0,0,1表示从右向左
                                        //     [
                                        //         {offset:0, color: '#FFFFFF'},
                                        //         {offset:1, color: '#1E7FFE'}
                                        //     ]),
                                    }
                                }
                            }
                        ]
                    })

                })


            },
        }
    }
</script>

<style lang="scss" scoped>
    .employmentFx{
        .professionEmployment{

        }
    }
</style>